import React from "react";
import { useParams } from "react-router-dom";

// Updated projects array with multiple images for each project
const projects = [
  {
    id: 1,
    name: "Project 1",
    description: "Description of Project 1.",
    details: "Additional details about Project 1.",
    images: [
      require("../project-images/Project1/jolibee.jpg"),
      require("../project-images/Project1/jolibee.jpg"),
      require("../project-images/Project1/167A3338.jpg"),
    ],
  },
  {
    id: 2,
    name: "Project 2",
    description: "Description of Project 2.",
    details: "Additional details about Project 2.",
    images: [
      require("../project-images/Project1/jolibee.jpg"),
      require("../project-images/Project1/jolibee.jpg"),
      require("../project-images/Project1/167A3338.jpg"),
    ],
  },
  {
    id: 3,
    name: "Project 3",
    description: "Description of Project 3.",
    details: "Additional details about Project 3.",
    images: [
      require("../project-images/Project1/jolibee.jpg"),
      require("../project-images/Project1/jolibee.jpg"),
      require("../project-images/Project1/167A3338.jpg"),
    ],
  },
];

function ProjectDetails() {
  const { id } = useParams();
  const project = projects.find((p) => p.id === parseInt(id));

  if (!project) {
    return <div>Project not found!</div>;
  }

  return (
    <div className="min-h-screen flex items-center justify-center text-white bg-black">
      <div className="max-w-3xl text-center">
        <h1 className="text-4xl font-bold mb-6">{project.name}</h1>

        {/* Project Images */}
        <div className="flex justify-center gap-4 overflow-hidden mb-6">
          {project.images.map((image, idx) => (
            <img
              key={idx}
              src={image}
              alt={`Project ${project.id} Image ${idx + 1}`}
              className="w-full max-w-lg h-80 object-cover rounded-lg"
              style={{
                border: "2px solid #00ff00",
                boxShadow: "0 0 15px #00ff00, 0 0 30px #00ff00",
              }}
            />
          ))}
        </div>

        <p className="text-lg">{project.details}</p>
      </div>
    </div>
  );
}

export default ProjectDetails;
